import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Authorize from '../../components/AuthComponent/Authorize';
import SaveButton from '../../components/Buttons/SaveButton';
import ButtonBar from '../../components/Fields/ButtonBar';
import Form from '../../components/Fields/Form';
import SwitchField from '../../components/Fields/SwitchField';
import TextboxField from '../../components/Fields/TextboxField';
import { FormConfig } from '../../components/Fields/Types';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import CurrencyModel from '../../models/CurrencyModel';
import DataService from '../../services/data.service';
import IdParams from '../../types/IdParams';
import { Result } from '../../types/Result';
import Unauthorized from '../Authentication/Unauthorized';

const CurrencyView: React.FC = () => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [isAuthorized, setIsAuthorized] = useState<boolean>(true);

    const [formData, setFormData] = useState<CurrencyModel>({
        id: 0,
        symbol: '',
        code: '',
        name: '',
        isActive: true,
        concurrencyId: '',
    });

    let idParams: IdParams = useParams();
    let currencyId: number | undefined;
    if (idParams.id && !Number.isNaN(parseInt(idParams.id))) {
        currencyId = parseInt(idParams.id);
    }

    useEffect(() => {
        if (currencyId !== undefined) {
            DataService.getById<CurrencyModel>('api/v1/currencies/', currencyId)
                .then(response => setFormData(response))
                .catch(e => {
                    if (e.response?.data?.status === 401)
                        setIsAuthorized(false);
                    else
                        handleException(e);
                });
        }
    }, [currencyId]);

    function submit() {
        if (formData) {
            if (formData.id === 0)
                DataService
                    .create<CurrencyModel>(`api/v1/currencies/`, formData)
                    .then(response => {
                        handleResult(response);
                        setServerErrors(response);
                        if (response.isSuccesful === true && response.data)
                            setFormData(response.data);
                    })
                    .catch(e => handleException(e));
            else
                DataService
                    .update<CurrencyModel>(`api/v1/currencies/`, formData)
                    .then(response => {
                        handleResult(response);
                        setServerErrors(response);
                        if (response.isSuccesful === true && response.data)
                            setFormData(response.data);
                    })
                    .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'symbol', label: 'Symbol', validationRules: [{ type: 'isRequired' }] },
            { name: 'code', label: 'Code' },
            { name: 'name', label: 'Name', validationRules: [{ type: 'isRequired' }] },
            { name: 'isActive', label: 'Active' },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    const { isAuthorizedFor } = useAuth();
    if (currencyId === undefined) {
        if (!isAuthorizedFor(ApplicationFunctions.EditCurrency)) {
            return (<Unauthorized />);
        }
    }
    else if (!isAuthorized) {
        return (<Unauthorized />);
    }

    return (
        <div className='main-content'>
            <Form title='Currency' footer={(
                <Row>
                    <Col md='12'>
                        <ButtonBar offset={2}>
                            <Authorize applicationFunction={ApplicationFunctions.EditCurrency}>
                                <SaveButton  {...getSubmitButtonProps()} />
                            </Authorize>
                        </ButtonBar>
                    </Col>
                </Row>
            )}>
                <Container fluid>
                    <Row>
                        <Col md='12'>
                            <TextboxField {...getFieldProps('symbol')} />
                            <TextboxField {...getFieldProps('code')} />
                            <TextboxField {...getFieldProps('name')} />
                            <SwitchField {...getFieldProps('isActive')} />
                        </Col>
                    </Row>
                </Container>
            </Form>
        </div>
    );
}
export default CurrencyView;